import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  csrf_token: null,
};

export const csrfSlice = createSlice({
  name: 'csrfToken',
  initialState,
  reducers: {
    storeCsrfToken: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const retriveCsrfToken = (state) => state;
export const { storeCsrfToken } = csrfSlice.actions;

export default csrfSlice.reducer;
